export function checkEmail(strEmail) {
    var strRegExp = /^[a-zA-Z0-9_.-]{2,}@[a-zA-Z0-9-]+\.[a-zA-Z0-9]{2,}$/;
    return strRegExp.test(strEmail);
}

export function checkPassword(strPassword) {
	var strRegExp = /[A-Za-z0-9]*[0-9]+[a-z0-9]*[A-Z]+[a-z0-9A-Z]*|[A-Za-z0-9]*[A-Z]+[a-z0-9]*[0-9]+[a-z0-9A-Z]*/;
	return strRegExp.test(strPassword);
}

export function trim(strText) {
	for (let i = 0; i < strText.length; i++) {
		if (strText.charAt(i) === " ")
			strText = strText.substring(i + 1, strText.length);
		else
			break;
	}

	for (let i = strText.length - 1; i >= 0; i = strText.length - 1) {
		if (strText.charAt(i) === " ")
			strText = strText.substring(0, i);
		else
			break;
	}
	return strText;
}

export function ValidarCuit(cuit) {
	 cuit = cuit.replace(/\D/g, '');

	 if (cuit.length !== 11) {
		 return false;
	 }
 	 const coeficientes = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
	 const numero = cuit.slice(0, 10);
	 const digitoVerificador = parseInt(cuit[10]);
 
	 let total = 0;
	 for (let i = 0; i < coeficientes.length; i++) {
		 total += parseInt(numero[i]) * coeficientes[i];
	 }
 
	 const modulo = total % 11;
	 let digitoCalculado;
 
	 if (modulo === 0) {
		 digitoCalculado = 0;
	 } else if (modulo === 1) {
		 digitoCalculado = 9;
	 } else {
		 digitoCalculado = 11 - modulo;
	 }
 
	 return digitoCalculado === digitoVerificador;
}

export function FormatCuit(value) {
	var cuit = value.match(/(\d{2})(\d{8})(\d{1})/);
	return cuit[1] + "-" + cuit[2] + "-" + cuit[3];
}

export function validarEmail(email) {
	let objRegExp1 = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
	return email.length > 0 ? objRegExp1.test(email) : false;
}

export function validarNroFactura(factura) {
	var objRegExp = /^[\d\s\-/\s]+$/;
	return factura.length > 0 ? objRegExp.test(factura) : false;
}